import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { RawHTML } from '../raw-html';
import './dx-tooltip-question.scss';
export var TOOLTIP_TYPES;
(function (TOOLTIP_TYPES) {
    TOOLTIP_TYPES["RIGHT"] = "right";
})(TOOLTIP_TYPES || (TOOLTIP_TYPES = {}));
const CONTAINER_CLASSES = {
    [TOOLTIP_TYPES.RIGHT]: 'dx-tooltip__container-right',
};
const getContainerClasses = (type) => {
    const common = 'dx-tooltip__container dx-tooltip__container-gray';
    return [common, CONTAINER_CLASSES[type]].join(' ');
};
let tooltipIdCounter = 0;
export const DxTooltipQuestion = ({ tooltipText, type, label = 'More information', }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const triggerRef = useRef(null);
    const panelId = useMemo(() => {
        tooltipIdCounter += 1;
        return `dx-tooltip-panel-${tooltipIdCounter}`;
    }, []);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    // Close on Escape and return focus to the trigger
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                close();
                triggerRef.current?.focus();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        // eslint-disable-next-line consistent-return
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen, close]);
    // Close when focus leaves
    const onBlurContainer = (event) => {
        if (!containerRef.current?.contains(event.relatedTarget)) {
            close();
        }
    };
    return (<div ref={containerRef} className={getContainerClasses(type)} onMouseEnter={open} onMouseLeave={close} onBlur={onBlurContainer}>
      <button ref={triggerRef} type="button" className="dx-tooltip__icon-question" aria-label={label} aria-expanded={isOpen} aria-controls={panelId} onClick={toggle} onFocus={open}/>
      <div id={panelId} className="dx-tooltip" style={isOpen ? { display: 'block' } : undefined}>
        <div className="dx-tooltip__inner" data-test-id="tooltip-inner">
          <RawHTML>{tooltipText}</RawHTML>
        </div>
      </div>
    </div>);
};
